import {PageTypes, Title} from "@/reference";

export default {
  methods: {
    computedTitle(file) {
      let stringType = '';
      const isAFile = file.type === 'image/jpeg' || file.type === 'application/pdf';

      if (isAFile) {
        stringType = 'Upload Prescription File';
      } else if (file.pagetype === undefined) {
        stringType = 'File';
      } else if (file.pagetype === PageTypes.customform) {
        stringType = file.customform
      } else if (file.pagetype === PageTypes.labtest) {
        stringType = 'Lab Request';
      } else if (file.pagetype === PageTypes.educ) {
        stringType = file.title;
      } else {
        stringType = Title[file.pagetype]
      }

      return isAFile ? stringType : `${stringType} from ${file.doctorname}`;
    },
  }
}